import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  manageSpacesDialogHeading: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.heading.spaces',
    description: 'Manage spaces dialog heading',
    defaultMessage: 'Manage linked Jira spaces',
  },
  manageSpacesDialogDetailsWorkItems: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.details.workItems.spaces',
    description: 'Manage spaces dialog details work items',
    defaultMessage:
      'Link Jira spaces to this repository by including a work item key in any branch name or commit. Alternatively you can manually select a space below.',
  },
  errorLoadingSpacesMessage: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.errorLoadingProjectsMessage.spaces',
    description: 'Message displayed when failed to load linked spaces.',
    defaultMessage: `We can't load the space list.`,
  },
  unlinkSpaceLabel: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.unlinkProjectLabel.spaces',
    description: 'Unlink space label.',
    defaultMessage: 'Unlink space',
  },
  linkedSpacesTitle: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.linkedProjectsTitle.spaces',
    description: 'Linked spaces list title.',
    defaultMessage: 'Linked spaces',
  },
  automaticallyLinkedProjectLabel: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.automaticallyLinkedProjectLabel',
    description: 'Label for a project that was linked automatically.',
    defaultMessage: 'Linked via commit/pull request',
  },
  manuallyLinkedProjectLabel: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.manuallyLinkedProjectLabel',
    description: 'Label for a project that was linked manually.',
    defaultMessage: 'Manually linked by {personName}',
  },
  closeManageSpacesDialogLabel: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.closeManageProjectsDialogLabel.spaces',
    description: 'Close manage spaces dialog label.',
    defaultMessage: 'Close manage spaces dialog',
  },
  manuallyLinkSpaceTitle: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.manuallyLinkProjectTitle.spaces',
    description: 'Manually link space title.',
    defaultMessage: 'Manually link space',
  },
  unlinkSpaceTitle: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.unlinkProjectTitle.spaces',
    description: 'Unlink space title.',
    defaultMessage: 'Unlink space',
  },
  unlinkSpaceDetails: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.unlinkProjectDetails.spaces',
    description: 'Unlink space details.',
    defaultMessage:
      '<p>Are you sure that you want to unlink the <b>{projectName} ({projectKey})</b> space from this repository?</p>' +
      '<p>You can link this space again in the future by manually linking it from \u2018Manage linked spaces\u2019.</p>',
  },
  unlinkProjectCancel: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.unlinkProjectCancel',
    description: 'Unlink project dialog cancel button.',
    defaultMessage: 'Cancel',
  },
  unlinkProjectConfirm: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.unlinkProjectConfirm',
    description: 'Unlink project dialog confirm button.',
    defaultMessage: 'Confirm',
  },
  linkSpaceFailedMessage: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.linkProjectFailedMessage.spaces',
    description: 'Failed to link space message.',
    defaultMessage: 'Failed to link space',
  },
  linkSpaceSuccessMessage: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.linkProjectSuccessMessage.spaces',
    description: 'Space linked successfully message.',
    defaultMessage: 'Space linked successfully',
  },
  unlinkSpaceFailedMessage: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.unlinkProjectFailedMessage.spaces',
    description: 'Failed to unlink space message.',
    defaultMessage: 'Failed to unlink space',
  },
  unlinkSpaceSuccessMessage: {
    id: 'frontbucket.jiraTab.manageProjectsDialog.unlinkProjectSuccessMessage.spaces',
    description: 'Space unlinked successfully message.',
    defaultMessage: 'Space unlinked successfully',
  },
});
